import React from 'react';

import { Checkbox } from 'antd';

import styled from 'styled-components';

import { getContactName } from '@hooks/API/Contact/UseContactsList';

import NwDivider from '@components/Gui/NwDivider';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    .attachments-list {
        .attachment-item {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 1rem;
            margin-bottom: 1rem;
            .attachment-item-checkbox {
                padding-top: 0.15rem;
            }
            .attachment-item-content {
                h2 {
                    font-size: ${(props) => props.theme.FontSizeBase};
                    font-weight: 600;
                    margin: 0;
                }
                p {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    margin: 0;
                    text-transform: uppercase;
                    color: ${(props) => props.theme.TextColorMuted};
                }
                span.is-hidden {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    color: ${(props) => props.theme.DangerColor};
                    text-transform: uppercase;
                }
            }
        }
    }
`;

const Attachments = ({ attachments, onUpdateAttachments, modelId }) => {
    const includeAttachment = (attachmentID, include) => {
        const updatedAttachments = attachments.map((attachment) => {
            if (attachment.ID === attachmentID) {
                attachment.Include = include;
            }
            return attachment;
        });
        onUpdateAttachments(updatedAttachments);
    };

    const getDescription = (attachment) => {
        let description = '';
        if (attachment.EventName) {
            description = `uploaded on event: ${attachment.EventName}`;
        } else {
            if (attachment.ProjectName) {
                description = `uploaded on project: ${attachment.ProjectName}`;
            } else {
                description = 'uploaded on a non-booking event';
            }
        }
        if (attachment.ContactID) {
            description += ` for ${getContactName(modelId)}`;
        }
        return description;
    };

    return (
        <Wrapper>
            <NwDivider textSize="big" dark>
                ATTACHMENTS
            </NwDivider>
            <div className="attachments-list">
                {attachments.map((attachment) => (
                    <div key={attachment.ID} className="attachment-item">
                        <div className="attachment-item-checkbox">
                            <Checkbox
                                checked={attachment.Include}
                                onChange={(e) => includeAttachment(attachment.ID, e.target.checked)}
                            />
                        </div>
                        <div className="attachment-item-content">
                            <h2>{attachment.Title}</h2>
                            <p>{getDescription(attachment)}</p>
                            {attachment.IsHidden && (
                                <span className="is-hidden">
                                    <NwIcon icon={byPrefixAndName.fasl['eye-slash']} /> hidden to models/talents
                                </span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </Wrapper>
    );
};

export default Attachments;
